import { htmlToPlainText } from './htmlText.ts'
import { getJobSearchDescription } from './jobRecommendation.ts'

/**
 * The record of a job in the Typesense `jobs` collection. The one mapping for the Cloud Function
 * that syncs jobs and the backfill scripts. The collection schema is in
 * scripts/typesense/01-create-collections.ts; the embedding is computed by Typesense from
 * title (twice), summary, description, topics, orgName, geoCity and geoRegion.
 */
export function toJobSearchDocument(job: any, toMillis: (value: unknown) => number | undefined, now: number = Date.now()) {
    const createdAt = toMillis(job.createdAt) || now

    return {
        id: job.id,
        title: job.title,
        // Both "Náplň práce" and "Koho hľadáte"; it used to be only the first non-empty field
        description: getJobSearchDescription(job),
        summary: htmlToPlainText(job.summary) || htmlToPlainText(job.highlights),
        image: job.image || '',
        slug: job.slug,
        visibility: job.visibility,
        topics: job.topics || [],
        // Job type (internship, full-time, etc.) - array
        type: Array.isArray(job.type) ? job.type : job.type ? [job.type] : [],
        // Target audience (student_ss, student_vs, etc.) - array
        who: job.who || [],
        // Job locations (cities) - array
        jobLocation: job.jobLocation || [],
        // Work place type (homeoffice, office, hybrid) - array
        jobPlace: Array.isArray(job.jobPlace) ? job.jobPlace : job.jobPlace ? [job.jobPlace] : [],
        formOfCollaboration: Array.isArray(job.formOfCollaboration) ? job.formOfCollaboration : [],
        geoCity: job.geoCity || job.orgMeta?.city || '',
        geoCountry: job.geoCountry || 'SK',
        geoRegion: job.geoRegion || '',
        remote:
            job.remote === true ||
            job.remote === 'true' ||
            job.remote === 'hybrid' ||
            job.remote === 'homeoffice' ||
            job.remote === 'remote',
        startDate: toMillis(job.startDate),
        endDate: toMillis(job.endDate),
        orgName: job.orgMeta?.title || job.orgName || '',
        orgType: job.orgMeta?.type || '',
        orgImage: job.orgMeta?.image || '',
        orgId: job.orgId || job.orgMeta?.id || '',
        createdAt,
        // "Najnovšie" sorts by this: a draft can wait weeks before it goes live
        publishedAt: toMillis(job.publishedAt) || createdAt,
        updatedAt: toMillis(job.updatedAt) || now
    }
}

/** "Najnovšie": by the date a job went live. Jobs indexed before publishedAt existed come last. */
export const JOBS_NEWEST_FIRST_SORT = 'publishedAt(missing_values: last):desc,createdAt:desc'
